module.exports = __webpack_public_path__ + "fonts/f86d67b9/proxima_nova_bold-punc.woff2";